import React from 'react';
import styled from 'styled-components';
import { theme } from '../styles/GlobalStyles';

const AIAssistantContainer = styled.div`
  width: 100%;
  height: calc(100vh - 80px);
  padding: ${theme.spacing.lg};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: transparent;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: ${theme.spacing.md};
    height: calc(100vh - 60px);
  }
`;

const ComingSoonContainer = styled.div`
  text-align: center;
  max-width: 500px;
  padding: 40px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  border: 1px solid #f0f1f3;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: 24px;
    border-radius: 12px;
    margin: 0 16px;
  }
`;

const ComingSoonTitle = styled.h1`
  color: ${theme.colors.primary};
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 16px;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 2rem;
    margin-bottom: 12px;
  }
`;

const ComingSoonSubtitle = styled.h2`
  color: #5f6368;
  font-size: 1.2rem;
  font-weight: 500;
  margin-bottom: 24px;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 1rem;
    margin-bottom: 20px;
  }
`;

const ComingSoonDescription = styled.p`
  color: #666;
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 32px;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 0.9rem;
    margin-bottom: 24px;
  }
`;

const FeatureList = styled.ul`
  text-align: left;
  color: #666;
  font-size: 0.95rem;
  line-height: 1.8;
  margin: 0;
  padding-left: 20px;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 0.85rem;
    padding-left: 16px;
  }
`;

const FeatureItem = styled.li`
  margin-bottom: 8px;
  
  &::marker {
    color: ${theme.colors.primary};
  }
`;

const AIAssistant: React.FC = () => {
  return (
    <AIAssistantContainer>
      <ComingSoonContainer>
        <ComingSoonTitle>Coming Soon</ComingSoonTitle>
        <ComingSoonSubtitle>AI Assistant - Your Personal Coach</ComingSoonSubtitle>
        <ComingSoonDescription>
          Your personal AI assistant is being trained to understand busy minds and provide 
          tailored support, insights, and guidance. This intelligent companion will help you 
          navigate daily challenges and optimise your productivity strategies.
        </ComingSoonDescription>
        
        <FeatureList>
          <FeatureItem>Smart task prioritisation and scheduling suggestions</FeatureItem>
          <FeatureItem>Personalised coping strategies for executive function challenges</FeatureItem>
          <FeatureItem>Real-time motivation and focus coaching</FeatureItem>
          <FeatureItem>Pattern recognition for your productivity cycles</FeatureItem>
          <FeatureItem>Meal planning assistance based on sensory preferences</FeatureItem>
          <FeatureItem>24/7 support for decision paralysis</FeatureItem>
        </FeatureList>
      </ComingSoonContainer>
    </AIAssistantContainer>
  );
};

export default AIAssistant; 